import { ServiceFetch } from '../service-fetch'

export default class DebitReceiptModel extends ServiceFetch {
    getDebitReceiptBy = (data) => this.authFetch({
        url: 'debit-receipt/getDebitReceiptBy',
        method: 'POST',
        body: JSON.stringify(data),
        name: "getDebitReceiptBy"
    })

    getDebitReceiptByCode = (data) => this.authFetch({
        url: 'debit-receipt/getDebitReceiptByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })
}